import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import "./FeaturesSection.scss";

function FeaturesSection(props) {
  const items = [
    {
      title: "Ecosystem",
      description:
        "Our core software platform uses <a href='https://www.zetonium.io' style={{color: 'blue', textDecoration: 'underline', borderBottom: '10px solid blue'}}>Żetonium</a>, our permissioned enterprise blockchain network that provides a stable and reliable system for recording and managing the provenance, structure and usage of data/IP stored in the cloud and on-premises.",
      image: "ecosystem_1.svg",
    },
    {
      title: "AI",
      description:
      "The PDS licensing framework enables applications, marketplaces and ecosystems to govern, track and monetize the use of data/IP by large language models (LLMs) and their users.",
      image: "ai_icon.svg",
    },
    {
      title: "License Exchange",
      description:
        "Our blockchain exchange platform, DASE (Digital Assets & Services Exchange) enables IP rights holders/licensees to audit IP usage in real time, mint tradable “token” licenses, interface with AI/LLM systems and export data-backed assets to other blockchain networks.",
      image: "exchange.svg",
    },
    {
      title: "Developer Platform",
      description:
        "Developers use PDS APIs to integrate our licensing functionality into new and existing applications. We also provide sample code, application templates/accelerators, toolkits and client libraries.",
      image: "api.svg",
    },
    {
      title: "Apps",
      description:
        "Enterprise customers use PDS applications to streamline, transform and expand their internal/external processes for data/IP licensing & governance. Our multi-tenant AppSuite supports white-label/custom UI integration and provides a simple and scalable solution for quickly registering/copyrighting and licensing data/IP assets across multiple parties, from creator to distributor to consumer.",
      image: "apps.svg",
    },
  ];

  return (
    <Section
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container">
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={3}
          spaced={true}
          className="has-text-centered"
          subBackgroundImage={props.backgroundImage}
        />
        <div className="FeaturesSection__features">
          {items.map((item, index) => (
            <div
              className="FeaturesSection__columns columns is-variable is-8 is-vcentered has-text-centered-mobile"
              key={index}
            >
              <div className="column is-half">
                <h3 className="FeaturesSection__title title has-text-weight-bold is-spaced is-3">
                  {item.title}
                </h3>
                <p className="subtitle" dangerouslySetInnerHTML={{__html: item.description}}></p>
              </div>
              <div className="column">
                <figure className="FeaturesSection__image image">
                  <img src={item.image} alt={item.title} />
                </figure>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}

export default FeaturesSection;

